import React from "react";
import FadeLoader from 'react-spinners/FadeLoader'

export const LoaderAnimate = () => {
    const cssOverride  = {
        display: "block",
        margin: "0 auto",
        borderColor: "red",
      };

  return (
    <FadeLoader color='#00bbec' loading={true} cssOverride={cssOverride} />
  )
}
